import './assets/main.css'
import '@appmax_npm/ds-appmax-v3/dist/style.css'
import { createApp } from 'vue'
import { Vue3Mq } from 'vue3-mq'
import { createPinia } from 'pinia'
import { configureAppmaxDS } from '@appmax_npm/ds-appmax-v3'
import AmDSPrime from '@appmax_npm/ds-prime'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { setUnauthorizedHandler } from '@/services/http'
import { useAuthStore } from '@/stores/auth'
import { purgeLegacyCredentials } from '@/services/purgeLegacyCredentials'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import env from './config'
import formatter from './services/formatter'
import directives from './directives';

async function bootstrap() {
  purgeLegacyCredentials()

  if (import.meta.env.VITE_USE_MOCKS === 'true') {
    const { startWorker } = await import('./mocks')
    await startWorker()
  }

  const app = createApp(App)
  const pinia = createPinia()
  const appmaxDS = configureAppmaxDS()

  app.use(Vue3Mq, {
    breakpoints: {
      mobile: 0,
      tablet: 767,
      desktop: 1200
    }
  })
  app.use(router)
  app.use(i18n)
  app.use(pinia)
  app.use(appmaxDS)
  app.use(AmDSPrime)

  pinia.use(piniaPluginPersistedstate)

  setUnauthorizedHandler(async () => {
    useAuthStore(pinia).clearSession()

    if (router.currentRoute.value.name !== 'login') {
      await router.push({ name: 'login' })
    }
  })

  app.provide('env', env)
  app.provide('formatter', formatter)

  Object.keys(directives).forEach((key) => {
    app.directive(key, directives[key]);
  });

  app.mount('#app')
}

bootstrap()